import icon1 from "../assets/5 WYL/checklist.png";
import icon2 from "../assets/5 WYL/communication.png";
import icon3 from "../assets/5 WYL/data (1).png";
import icon4 from "../assets/5 WYL/data.png";
import icon5 from "../assets/5 WYL/file.png";
import icon6 from "../assets/5 WYL/hypothesis.png";
import icon7 from "../assets/5 WYL/management.png";
import icon8 from "../assets/5 WYL/mouse.png";
import icon9 from "../assets/5 WYL/thought.png";

import img1 from '../assets/NewCard/ai.jpg'
import img2 from '../assets/NewCard/SEM copy.jpg'
import img3 from '../assets/NewCard/SPSS new copy.jpg'
import img4 from '../assets/NewCard/Paper Writing copy.jpg'
import img5 from '../assets/NewCard/Bivariate copy.jpg'
import img6 from '../assets/NewCard/VoSviewer copy.jpg'
import img7 from '../assets/NewCard/Research Methodology copy.jpg'

import Learn1 from "../assets/7 benefits of learn/Icon1.svg";
import Learn2 from "../assets/7 benefits of learn/Icon2.svg";
import Learn3 from "../assets/7 benefits of learn/Icon3.svg";
import Learn4 from "../assets/7 benefits of learn/Icon4.svg";
import Learn5 from "../assets/7 benefits of learn/Icon5.svg";
import Learn6 from "../assets/7 benefits of learn/Icon6.svg";
import Learn7 from "../assets/7 benefits of learn/Icon7.svg";

import bundle from "../assets/6 save with bundle/Bundle.jpg";

export const WYLearn = [
  {
    icon: icon1,
    title: "Essential Research Concepts",
    para: "Grasp the foundational principles of research and the critical role of literature reviews in shaping your work.",
  },
  {
    icon: icon2,
    title: "Crafting Strong Hypotheses",
    para: "Learn how to formulate hypotheses that drive your research direction and provide clarity in your study.",
  },
  {
    icon: icon3,
    title: "Designing Impactful Questionnaires",
    para: "Discover techniques to create questionnaires that gather insightful data, enhancing your research quality.",
  },
  {
    icon: icon4,
    title: "Selecting the Right Research Design",
    para: "	Strengthen your ability to critically assess research, fostering a mindset of continuous improvement and innovation.",
  },
  {
    icon: icon5,
    title: "Mastering Data Collection Methods",
    para: "Equip yourself with a variety of data collection strategies, ensuring your research is thorough and reliable.",
  },
  {
    icon: icon6,
    title: "Analyzing and Interpreting Data",
    para: "Develop skills to analyze data effectively, transforming raw numbers into meaningful insights that inform decisions.",
  },
  {
    icon: icon7,
    title: "Communicating Your Findings",
    para: "	Strengthen your ability to critically assess research, fostering a mindset of continuous improvement and innovation.",
  },
  {
    icon: icon8,
    title: "Efficient Reference Management",
    para: "Utilize Mendeley to streamline your referencing process, saving time and enhancing your writing’s credibility.",
  },
  {
    icon: icon9,
    title: "Cultivating Critical Thinking",
    para: "	Strengthen your ability to critically assess research, fostering a mindset of continuous improvement and innovation.",
  },
];

export const BOLearning = [
  {
    icon: Learn1,
    bgColor: "#CC000133",
    title: "Soft copy of materials ",
    para: "Apply real-world skills with expert support in live sessions",
  },
  {
    icon: Learn2,
    bgColor: " #FB940B33",
    title: "Recording Access",
    para: "15 days recording access to course content.",
  },
  {
    icon: Learn3,
    title: "Basic to Advanced Training",
    bgColor: "#FFFF0133",
    para: " Progress through all levels.",
  },
  {
    icon: Learn4,
    title: "Certificate of Participation",
    bgColor: "#01CC0033",
    para: "Official recognition of your expertise.",
  },

  {
    icon: Learn6,
    title: "Mentor Guidance",
    bgColor: "#762CA733",
    para: "Get real-time advice and support from experts during live sessions!",
  },
  {
    icon: Learn7,
    title: "Interactive Session",
    bgColor: "#F700F633",
    para: "Real-time learning with expert guidance.",
  },
];

export const testimonials = [
  {
    name: "James Pattinson",
    rating: "4",
    para: `This course helped me transition into a data science role. It covers everything from data wrangling
     to predictive analytics, and the career support with resume tips and mock interviews was a huge bonus.`,
  },
  {
    name: "Smith",
    rating: "5",
    para: `This course helped me transition into a data science role. It covers everything from data wrangling
     to predictive analytics, and the career support with resume tips and mock interviews was a huge bonus.`,
  },
  {
    name: "marshal",
    rating: "5",
    para: `This course helped me transition into a data science role. It covers everything from data wrangling
     to predictive analytics, and the career support with resume tips and mock interviews was a huge bonus.`,
  },
  {
    name: "Micheal",
    rating: "4",
    para: `This course helped me transition into a data science role. It covers everything from data wrangling
     to predictive analytics, and the career support with resume tips and mock interviews was a huge bonus.`,
  },
];

export const FAQuestions = [
  {
    title: "Will I get Recording?",
    points: "Yes, Valid for 15 Days.",
  },
  {
    title: "Will I get a refund?",
    points: "Yes, Before the Program Begins.",
  },
  {
    title: "Is it a Live Interactive session?",
    points: "Yes.",
  },
  {
    title: "Will I get an E – Certificate?",
    points:
      "Yes, we will issue E- Certificate of Participation, you have to fill the feedback form at the last day.",
  },
  {
    title: "Can I expect practical examples from the session?",
    points:
      "Yes, It is not just a theoretical presentation, our mentors will give you live examples.",
  },
  {
    title: "What support will I get post the session?",
    points:
      "Stay Connected with our Professors &amp; Researchers Group to collaborate, Access PPT for Life, Watch Video for 15 Days Post the Program.",
  },
  {
    title: "Who Should attend?",
    points:
      "UG / PG Students ,M.Phil/ Ph.D Scholars ,Teaching Professionals from College / Universities ,Industry People.",
  },
];


export const recorded_course = [
  {
    name: "AI Tools in Education & Research",
    link: "https://pages.razorpay.com/STCAITOOLS",
    img: img1,
    btnText: "Join Now",
    rating: "4.9",
  },
  {
    name: "Short Term Course on Structural Equation Modeling (SEM) Using AMOS",
    link: "https://pages.razorpay.com/STCSEM",
    img: img2,
    btnText: "Join Now",
    rating: "4.9",
  },
  {
    name: "STC-Statistical Tests Using SPSS",
    link: "https://pages.razorpay.com/STCSPSS",
    img: img3,
    btnText: "Join Now",
    rating: "4.9",
  },
  {
    name: "Short Term Course on Writing & Publishing Research Papers in Scopus / Wos Indexed Journals ",
    link: "https://pages.razorpay.com/STCRPW",
    img: img4,
    btnText: "Join Now",
    rating: "4.9",
  },
  {
    name: "Short Term Course on Bivariate and Multivariate Data Analysis Using SPSS ",
    link: "https://pages.razorpay.com/STCSPSSBM",
    img: img5,
    btnText: "Join Now",
    rating: "4.9",
  },
  {
    name: "Short Term Course on Systematic Literature Review and Bibliometric Analysis Using Open Source Tools ",
    link: "https://pages.razorpay.com/STCSLRBA",
    img: img6,
    btnText: "Join Now",
    rating: "4.9",
  },
  {
    name: "Short Term Course on Research Methodology  ",
    link: "https://pages.razorpay.com/STCRM5",
    img: img7,
    btnText: "Join Now",
    rating: "4.9",
  },
];

export const Course_bundle = [
  {
    combo: [
      { img: bundle, course_name: "Research Methodology" },
      { img: bundle, course_name: "Research Methodology" },
    ],
    number_of_courses: "2 Courses",
  },
  {
    combo: [
      { img: bundle, course_name: "Research Methodology" },
      { img: bundle, course_name: "Research Methodology" },
    ],
    number_of_courses: "2 Courses",
  },
  {
    combo: [
      { img: bundle, course_name: "Research Methodology" },
      { img: bundle, course_name: "Research Methodology" },
    ],
    number_of_courses: "2 Courses",
  },
  {
    combo: [
      { img: bundle, course_name: "Research Methodology" },
      { img: bundle, course_name: "Research Methodology" },
    ],
    number_of_courses: "2 Courses",
  },
  {
    combo: [
      { img: bundle, course_name: "Research Methodology" },
      { img: bundle, course_name: "Research Methodology" },
    ],
    number_of_courses: "2 Courses",
  },
];
